import { msg } from '@lit/localize';
import { i18nCache } from '@tmf-ui-routes/i18n-cache';

export const langSegment = (): string => (i18nCache['lang'] ??= msg('en'));
